'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.transform = exports.backgroundProps = exports.sizeProps = exports.borderRadius = exports.border = undefined;

var _styledComponents = require('styled-components');

var _reactackleCore = require('reactackle-core');

var border = exports.border = function border(_ref) {
  var border = _ref.border,
      borderWidth = _ref.borderWidth,
      colorScheme = _ref.colorScheme,
      customColor = _ref.customColor,
      sizeKey = _ref.sizeKey,
      themeFromProvider = _ref.theme;

  var theme = (0, _reactackleCore.extractThemeOrDefault)(themeFromProvider);
  var path = theme.reactackle.components.icon;
  var customWidth = borderWidth > 0 && borderWidth;
  var themeWidth = sizeKey !== 'custom' ? path.size[sizeKey].borderWidth : 1;
  var bWidth = customWidth || themeWidth;

  var color = path.color[colorScheme];

  return border && (0, _styledComponents.css)(['border:solid ', 'px ', ';'], bWidth, customColor || color);
};

var borderRadius = exports.borderRadius = function borderRadius(_ref2) {
  var rounded = _ref2.rounded,
      themeFromProvider = _ref2.theme;

  var theme = (0, _reactackleCore.extractThemeOrDefault)(themeFromProvider);

  var borderRadius = rounded ? '50%' : (0, _reactackleCore.getValueString)(theme.reactackle.components.icon.borderRadius);

  return '\n    border-radius: ' + borderRadius + ';\n  ';
};

var sizeProps = exports.sizeProps = function sizeProps(_ref3) {
  var themeFromProvider = _ref3.theme,
      sizeKey = _ref3.sizeKey,
      border = _ref3.border,
      rounded = _ref3.rounded;

  var theme = (0, _reactackleCore.extractThemeOrDefault)(themeFromProvider);
  var path = theme.reactackle.components.icon;

  var width = sizeKey !== 'custom' ? path.size[sizeKey].width || path.size[sizeKey].height : 'inherit';

  var height = sizeKey !== 'custom' ? path.size[sizeKey].height || path.size[sizeKey].width : 'inherit';

  var imgSize = null;
  if (sizeKey !== 'custom') {
    if (border) {
      if (rounded) imgSize = path.size[sizeKey].roundedImgSize || path.size[sizeKey].borderedImgSize || path.size[sizeKey].imgSize || height;else imgSize = path.size[sizeKey].borderedImgSize || path.size[sizeKey].imgSize || height;
    } else imgSize = path.size[sizeKey].imgSize || height;
  }

  return (0, _styledComponents.css)(['', ''], (0, _reactackleCore.iconSizeMixin)((0, _reactackleCore.getValueString)(height), (0, _reactackleCore.getValueString)(imgSize), (0, _reactackleCore.getValueString)(width)));
};

var backgroundProps = exports.backgroundProps = function backgroundProps(_ref4) {
  var backgroundColor = _ref4.backgroundColor;
  return backgroundColor && '\n  background-color: ' + backgroundColor + ';\n';
};

var transform = exports.transform = function transform(_ref5) {
  var flip = _ref5.flip,
      rotate = _ref5.rotate;

  var iconFlip = '',
      iconRotate = '';

  if (flip === 'horizontal') iconFlip = 'scale(-1, 1);';else if (flip === 'vertical') iconFlip = 'scale(1, -1);';

  if (rotate) iconRotate = 'rotate(' + rotate + 'deg)';

  return iconFlip || iconRotate ? 'transform: ' + iconFlip + ' ' + iconRotate + ';' : '';
};


//////////////////
// WEBPACK FOOTER
// ./~/reactackle-icons/dist/styles/styleMixins.js
// module id = 217
// module chunks = 0